import React, {useEffect} from "react"
import "./index.scss"
import LegendBarChart from "../../components/Charts/BarChart/LegendBarChart"
import ChartContainer from "../../components/Charts/ChartContainer"
import {useManualQuery} from "graphql-hooks"
import {UseStores} from "../../hooks/UseStores"
import {observer} from "mobx-react-lite"
import {MONTH_OVER_MONTH_FOOT_TRAFFIC_QUICK_VIEW} from "../../gql/gqlInsights"
import {insightClient} from "../../gql/gqlInterceptor"
import {Spinner} from "../../components/Spinner"
import InternalError from "../../components/InternalError"
import EmptyDataContainer from "../../pages/Insights/EmptyDataContainer"

const MonthOverMonthFootTraffic = () => {
  let domChart = null
  let query = MONTH_OVER_MONTH_FOOT_TRAFFIC_QUICK_VIEW
  const label = "Month over Month Share of Foot Traffic"
  const type = "month_over_month_foot_traffic"

  const {insightStore, insightsPopupStore} = UseStores()

  const brandId = insightStore.brandId
  const month = insightStore.insightMonth
  const marketType = insightStore.insightMarketType
  const marketTypeValue = insightStore.insightMarketTypeValue
  const skipCache = insightsPopupStore.skipCacheForMOM
  let chartData = []

  const [fetchData, {loading, error, data}] = useManualQuery(query, {
    variables: {brandId, month, marketType, marketTypeValue},
    client: insightClient,
    skipCache: skipCache,
  })

  useEffect(() => {
    if (month !== "") {
      fetchData()
    }
  }, [month, brandId, marketType, marketTypeValue])

  if (loading) {
    domChart = (
      <div align="center">
        <Spinner size="medium" />
      </div>
    )
  }

  if (error) {
    insightsPopupStore.setSkipCacheForMOM(true)
    domChart = (
      <div className="error-message-container">
        <InternalError />
      </div>
    )
  }
  if (data && data.quickView) {
    insightsPopupStore.setSkipCacheForMOM(false)

    const monthOverMonthFootTraffic = data.quickView.momFootTraffic

    if (monthOverMonthFootTraffic.length === 0) {
      domChart = <EmptyDataContainer />
    } else {
      const percentageVisits = []

      for (let i = 0; i < monthOverMonthFootTraffic.length; i++) {
        let totalMonthVisits = 0
        for (let j = 0; j < monthOverMonthFootTraffic[i].brand.length; j++) {
          totalMonthVisits += monthOverMonthFootTraffic[i].brand[j].visits
        }

        percentageVisits.push([])

        for (let k = 0; k < monthOverMonthFootTraffic[i].brand.length; k++) {
          if (totalMonthVisits > 0)
            percentageVisits[i].push(
              Number(
                (
                  (monthOverMonthFootTraffic[i].brand[k].visits / totalMonthVisits) *
                  100
                ).toFixed(2)
              )
            )
          else percentageVisits[i].push(0)
        }
      }

      for (let l = 1; l < percentageVisits.length; l++) {
        chartData.push({Month: monthOverMonthFootTraffic[l].month})

        for (let m = 0; m < percentageVisits[l].length; m++) {
          if (monthOverMonthFootTraffic[l].brand[m]) {
            chartData[l - 1][monthOverMonthFootTraffic[l].brand[m].brandName] = Number(
              (percentageVisits[l][m] - percentageVisits[l - 1][m]).toFixed(1)
            )
          }
        }
      }

      domChart = (
        <LegendBarChart
          xDataKey="Month"
          chartData={chartData}
          labelList={true}
          labelSize="10px"
          barSize={12}
          barGap={28}
          chartHeight={264}
          marginRight={16}
          legendPosBottom={-20}
        />
      )
    }
  }

  return (
    <ChartContainer type={type} label={label} hideDownload={true}>
      {domChart}
    </ChartContainer>
  )
}
export default observer(MonthOverMonthFootTraffic)
